<template>
  <div style="height:500px;" />
</template>

<script>
    export default {
        data() {
            return {
                flowScheme: [],
                user: {}
            };
        },
        methods: {
            initalTask: function() {
                
                }
        },
        computed: {
            task: function() {
                return this.$store.state.task.curTask;
            },
            tabIndex: function() {
                return this.$store.state.task.tabIndex;
            }
        },
        watch: {
            task: function(newvalue) {
                if (!newvalue) return;
                this.initalTask();
            },
            tabIndex: function(newvalue) {
                if (!newvalue) return;
                this.initalTask();
            }
        },
        mounted() {
        }
    };
</script>